import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import '@shoelace-style/shoelace/dist/components/drawer/drawer.js';
import '@shoelace-style/shoelace/dist/components/icon-button/icon-button.js';
import assert from 'assert';

@customElement('vxc-drawer')
export class TDrawer extends LitElement {
    @property({ type: String, attribute: 'brand' })     brandName = '';
    @property({ type: String, attribute: 'logo'  })     brandLogo = '';
  
    @state() private drawerOpen = false;
  
    static styles = css`
      :host {
        display: block;
      }
  
      .header {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        height: 64px;
        background-color: rgba(255, 255, 255, 0.8);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 16px;
        z-index: 100;
      }
  
      .brand {
        display: flex;
        align-items: center;
        gap: 12px;
      }
  
      .brand svg,
      .logo {
        height: 32px;
        width: auto;
      }
  
      .brand-name {
        font-size: 1.2rem;
        font-weight: 600;
        color: #333;
      }
  
      .menu-button {
        background: transparent;
        border: none;
        cursor: pointer;
        padding: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
      }
  
      .menu-button:hover {
        opacity: 0.8;
      }
  
      .menu-button svg {
        width: 24px;
        height: 24px;
      }
    
      sl-drawer {
        --z-index: 1000;
      }
  
      sl-drawer::part(body) {
        padding: 0;
      }
    `;
  
    private toggleDrawer() {
      this.drawerOpen = !this.drawerOpen;
    }

    private renderLogo(logo?: string) {
        var resp = html``
        try {
            console.log('render logo', unsafeHTML(logo))
            assert(logo?.length, 'no logo')
            if(logo.startsWith('<svg'))     resp = html`${unsafeHTML(logo)}`
            else resp = html`<img src="${logo}" alt="${this.brandName}" class="logo">`
            console.log('logo =', resp)
        }
        catch(e) { console.error(e) }
        finally  { return resp }
    }
  
    render() {
      return html`
        <div class="header">
          <div class="brand">
            ${this.renderLogo(this.brandLogo)}
            <span class="brand-name">${this.brandName}</span>
          </div>
          <button class="menu-button" @click=${this.toggleDrawer} aria-label="Toggle menu">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 12H20" stroke="#000000" stroke-width="2" stroke-linecap="round"></path>
              <path d="M5 17H20" stroke="#000000" stroke-width="2" stroke-linecap="round"></path>
              <path d="M5 7H20" stroke="#000000" stroke-width="2" stroke-linecap="round"></path>
            </svg>
          </button>
        </div>
  
        <sl-drawer
          label="Menu"
          placement="end"
          ?open=${this.drawerOpen}
          @sl-after-hide=${() => this.drawerOpen = false}
        >
          <slot></slot>
        </sl-drawer>
      `;
    }
  }

declare global {
  interface HTMLElementTagNameMap {
    'vxc-drawer': TDrawer;
  }
}